import { getCohortSendLinkCopy } from "../../../../../api/cohortContentOverrides";

/**
 * The scripted send-link ask shown to the expert.
 *
 * The Clark pilot supplies its own wording per SKU, so that takes precedence when the cohort flag is
 * on. Pilot copy may contain Markdown and the `==verbatim==` token, so the caller renders the result
 * through `RichPhrase` rather than as a plain string.
 */
export const getSendLinkCopy = (sendLinkCommTypeOverride?: string, productSku?: string, isCohortFlagOn = false) => {
    const cohortCopy = productSku ? getCohortSendLinkCopy(productSku, isCohortFlagOn) : undefined;
    if (cohortCopy) return cohortCopy;

    if (sendLinkCommTypeOverride === "SMS") {
        return "If that sounds like something you\u2019re interested in, can I text you the link to review the plan and subscribe?";
    }
    return "Can I text you a link to review important plan information and complete your enrollment?";
};
